import { useNavigate } from "react-router-dom";
import { ArrowLeft, FlaskConical } from "lucide-react";
import { AnalysisReport } from "@/components/AnalysisReport";
import { ANALYSIS_FIXTURE } from "@/lib/analysisFixture";

// Aperçu de l'écran d'analyse avec des données de TEST — aucun paiement, aucun appel API.
export default function AnalysisPreview() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[100dvh] bg-[#FAF7F2]">
      <div className="max-w-2xl mx-auto px-4 pt-4 flex items-center justify-between gap-3">
        <button onClick={() => navigate("/")} data-testid="analysis-preview-back"
          className="inline-flex items-center gap-1.5 text-sm text-[#5C4A45] hover:text-[#6E2D38] transition-colors">
          <ArrowLeft className="w-4 h-4" /> Accueil
        </button>
        <span data-testid="analysis-preview-badge"
          className="inline-flex items-center gap-1.5 text-[11px] font-semibold tracking-wide uppercase text-[#8A6D3B] bg-[#F7F1E8] border border-[#E8DDD5] rounded-full px-3 py-1">
          <FlaskConical className="w-3.5 h-3.5" /> Aperçu · données de test
        </span>
      </div>
      <AnalysisReport analysis={ANALYSIS_FIXTURE} />
    </div>
  );
}
